import { Dataset } from '~/Api/Product/Dataset';

export enum ActionType {
	request = 'ProductDataset.request',
	receive = 'ProductDataset.receive',
	pruneAll = 'ProductDataset.pruneAll',
}

interface RequestAction {
	type: ActionType.request;
	request: Promise<any>;
	productId: string;
}

interface ReceiveAction {
	type: ActionType.receive;
	request: Promise<any>;
	productId: string;
	dataset: Dataset | null;
}

interface PruneAllAction {
	type: ActionType.pruneAll;
}

export type Action = RequestAction | ReceiveAction | PruneAllAction;
